<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <table class="table text-center table-condensed table-sm table-bordered" v-if="balance != null">
      <tbody>
      <tr class="table-b-table-default">
        <th colspan="3">
          Saldo Original de recibos
        </th>
      </tr>
      <tr>
        <td colspan="3" class="text-info">{{ balance.balanceKpi | moneda }}</td>
      </tr>
      <template v-if="balance.balancePorEstatusMovimientoDto.length > 0">
        <tr class="table-b-table-default">
          <th colspan="3">Movimientos</th>
        </tr>
        <tr class="table-b-table-default">
          <th>
            Estatus
          </th>
          <th>
            Balance
          </th>

        </tr>
        <tr v-for="balanceEstatus in balance.balancePorEstatusMovimientoDto"
            :key="balance.balancePorEstatusMovimientoDto.indexOf(balanceEstatus)">
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.descripcion }}
          </td>
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.balance | moneda }}
          </td>
        </tr>

      </template>

      <template v-if="balance.balancePorEstatusTransferenciaDto.length > 0">
        <tr class="table-b-table-default">
          <th colspan="3">Transferencias</th>
        </tr>
        <tr class="table-b-table-default">
          <th>
            Estatus
          </th>
          <th>
            Balance
          </th>
        </tr>
        <tr v-for="balanceEstatus in balance.balancePorEstatusTransferenciaDto"
            :key="balance.balancePorEstatusTransferenciaDto.indexOf(balanceEstatus)">
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.descripcion }}

          </td>
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.balance | moneda }}

          </td>
        </tr>
        <tr>
          <th>Sumatoria</th>
          <th>{{ balance.balanceTransferencias | moneda }}</th>
        </tr>
      </template>

      <template v-if="balance.balancePorEstatusCashbackDto.length > 0">
        <tr class="table-b-table-default">
          <th colspan="3">Cashback</th>
        </tr>
        <tr class="table-b-table-default">
          <th>
            Estatus
          </th>
          <th>
            Balance
          </th>
        </tr>
        <tr v-for="balanceEstatus in balance.balancePorEstatusCashbackDto"
            :key="balance.balancePorEstatusCashbackDto.indexOf(balanceEstatus)">
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.descripcion }}
          </td>
          <td :class="balanceEstatus.descripcion === 'Aceptado'? 'text-info': ''">
            {{ balanceEstatus.balance | moneda }}
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "BalancePorTipoMovimiento",
  props: {
    balance: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    calcularSaldo() {
      if (this.balance != null) {
        return this.balance.balanceKpi;
      } else {
        return 0;
      }

    }
  },
  computed: {
    getSaldoAfavor() {
      return this.calcularSaldo();
    }
  }
}
</script>

<style scoped>
.table-b-table-default {
  color: #ffffff !important;
  background-color: #0e6ba9 !important;
}

</style>